import React from "react";
import HeaderComponent from "../components/HeaderComponent/HeaderComponent";
import ZoomComponent from "../components/ZoomComponent/ZoomComponent";
import Goals from "../features/goals/Goals";
import "./Home.scss";
import ScrollContainer from 'react-indiana-drag-scroll';

export default function Home() {
  const ref = React.useRef(null);

  return (
    <>
      <HeaderComponent />
      <main ref={ref}>
        <ScrollContainer className="main-el" ignoreElements=".draggable-entity">
          <Goals />
        </ScrollContainer>
      </main>
      <ZoomComponent mainRef={ref} />
    </>
  );
}
